module.exports = __webpack_public_path__ + "static/media/sell_request_details_make_4.7a04bf60.png";